import { extendTheme } from "@chakra-ui/react";

const Theme = extendTheme({
  styles: {
    global: () => ({
      body: {
        fontSize: "62.5%",
        fontWeight: "400",
        bgGradient: "linear(to right, #530054, #641a65)",
        // bgGradient: "linear(to right, #240D23, #240D23)",
        color: "#FFE2FF",
        fontFamily: "Montserrat, sans-serif",
      },
      h1: {
        fontSize: { base: "1rem", sm: "1.6rem", md: "1.8rem" },
        fontWeight: "bold",
        textTransform: "Uppercase",
        color: "#EFB1FF",
      },
      h2: {
        fontSize: { base: "1.2rem", md: "1.4rem" },
        fontWeight: "bold",
        textTransform: "capitalize",
      },
      h3: {
        fontSize: "1.6rem",
      },
      h4: {
        fontSize: { base: "0.8rem", md: "1rem" },
        fontWeight: "bold",
      },
      h5: {
        fontSize: { base: "0.5rem", md: "0.9rem" },
      },

      h6: {
        fontSize: "0.7rem",
        fontWeight: "bold",
      },
      p: {
        fontSize: { base: "1.2rem", md: "2rem", lg: "1.6rem" },
        fontWeight: "200",
        lineHeight: "1.8",
      },
      colors: {
        primaryColor: "#530054",
        secondaryColor: "#641a65",
        textColor: "#FFE2FF",
        textColorVariant: "#FFF",
        colorDark: "#240D23 ",
      },
      button: {
        bg: "#874d87!important",
        color: "#FFE2FF !important",
        _hover: {
          bg: "#fff !important",
          color: "#530054 !important",
        },
      },
      "::-webkit-scrollbar": {
        width: "8px" /* Width of the scrollbar */,
      },
      "::-webkit-scrollbar-track": {
        background: "#530054" /* Background color of the track */,
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#530054" /* Color of the scrollbar thumb */,
        borderRadius: "10px" /* Rounded corners of the thumb */,
        border: "3px solid #530054" /* Space around the thumb */,
      },
      "*": {
        scrollbarWidth: "thin" /* Make the scrollbar thinner */,
        scrollbarColor:
          "#530054 transparent" /* Color of the thumb and track */,
      },
    }),
  },
});

export default Theme;
